export const TemplateType = Object.freeze({
	NewUsers: 'new_users',
	Usual: 'usual',
});
